import { CombinePdfFileFreeComponent } from './combine-pdf-file-free/combine-pdf-file-free.component';
import { ConvertPdfToExcelOnlineComponent } from './convert-pdf-to-excel-online/convert-pdf-to-excel-online.component';
import { RemovePdfPasswordOnlineComponent } from './remove-pdf-password-online/remove-pdf-password-online.component';
import { UnlockAPdfFileEasilyComponent } from './unlock-a-pdf-file-easily/unlock-a-pdf-file-easily.component';
import { WhatIsOCRPDFComponent } from './what-is-ocr-pdf/what-is-ocr-pdf.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { BlogMergePdfComponent } from './blog-merge-pdf/blog-merge-pdf.component';
import { BlogSplitPdfComponent } from './blog-split-pdf/blog-split-pdf.component';
import { BlogHtmlToImageComponent } from './blog-html-to-image/blog-html-to-image.component';
import { BlogPdfToWordComponent } from './blog-pdf-to-word/blog-pdf-to-word.component';
import { BlogHtmlToPdfComponent } from './blog-html-to-pdf/blog-html-to-pdf.component';
import { BlogUnlockPdfComponent } from './blog-unlock-pdf/blog-unlock-pdf.component';
import { BlogProtectPdfComponent } from './blog-protect-pdf/blog-protect-pdf.component';
import { BlogWatermarkPdfComponent } from './blog-watermark-pdf/blog-watermark-pdf.component';

import { BlogPdfToExcelComponent } from './blog-pdf-to-excel/blog-pdf-to-excel.component';
import { BlogWordToPngComponent } from './blog-word-to-png/blog-word-to-png.component';
import { BlogExcelToPdfComponent } from './blog-excel-to-pdf/blog-excel-to-pdf.component';
import { BlogPdfToImageComponent } from './blog-pdf-to-image/blog-pdf-to-image.component';
import { BlogImageToPdfComponent } from './blog-image-to-pdf/blog-image-to-pdf.component';

import { BlogWordToPdfComponent } from './blog-word-to-pdf/blog-word-to-pdf.component';
import { BlogOcrPdfComponent } from './blog-ocr-pdf/blog-ocr-pdf.component';
import { BlogPptxToPdfComponent } from './blog-pptx-to-pdf/blog-pptx-to-pdf.component';
import { BlogCompressPdfComponent } from './blog-compress-pdf/blog-compress-pdf.component';
import { ContectusComponent } from './contectus/contectus.component';




import { Routes } from '@angular/router';
import { FileUploadComponent } from './file-upload/file-upload.component'; 
// import { ApplicationConfig, Providers, Component } from '@angular/core';
// import { BrowserModule } from '@angular/platform-browser';
// import { provideHttpClient } from '@angular/common/http';
// import { RouterModule } from '@angular/router';
import { DocumentUploadComponent } from './../app/document-upload/document-upload.component';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { TermsNConditionsComponent } from './terms-n-conditions/terms-n-conditions.component';
import { PrivacyNPolicyComponent } from './privacy-n-policy/privacy-n-policy.component';

import { BlogToolComponent } from './blog-tool/blog-tool.component';
// import { BlogComponent } from './blog/blog.component';
import { CopyTextFromPdfComponent } from './copy-text-from-pdf/copy-text-from-pdf.component';
import { HowToExtractPagesFromPdfComponent } from './how-to-extract-pages-from-pdf/how-to-extract-pages-from-pdf.component';
import { MergePdfFileToOneFileComponent } from './merge-pdf-file-to-one-file/merge-pdf-file-to-one-file.component';
import { ConvertExcelToPdfComponent } from './convert-excel-to-pdf/convert-excel-to-pdf.component';
import { ConvertWordToPngComponent } from './convert-word-to-png/convert-word-to-png.component';
import { JourneyOfPdfComponent } from './journey-of-pdf/journey-of-pdf.component';
import { PdfFilesWithoutSoftwareComponent } from './pdf-files-without-software/pdf-files-without-software.component';


// Import your component



// export const routes: Routes = [
//   // { path: 'upload', component: FileUploadComponent },
//   // { path: '', redirectTo: '/upload', pathMatch: 'full' }, // Redirect to the upload page by default
//   { path: 'pdf-merge', component: DocumentUploadComponent },
//    { path: 'pdf-converter', component: DocumentUploadComponent },
//  { path: '**', redirectTo: '/pdf-converter' } // Wildcard route for a 404 page
//   // { path: '**', redirectTo: 'upload' } // Default route
// ];

export const routes: Routes = [
  { path: 'pdf-merge', component: AppComponent },
  { path: 'pdf-split', component: AppComponent },
  { path: 'html-to-image', component: AppComponent },
  { path: 'pdf-to-word', component: AppComponent },
  { path: 'html-to-pdf', component: AppComponent },
  { path: 'unlock-pdf', component: AppComponent },
  { path: 'protect-pdf', component: AppComponent },
  { path: 'watermark-pdf', component: AppComponent },
  { path: 'pdf-to-excel', component: AppComponent },
  { path: 'word-to-png', component: AppComponent },
  { path: 'excel-to-pdf', component: AppComponent },
  { path: 'pdf-to-image', component: AppComponent },
  { path: 'image-to-pdf', component: AppComponent },
  { path: 'word-to-pdf', component: AppComponent },
  { path: 'ocr-pdf-image', component: AppComponent },
  { path: 'compress-pdf', component: AppComponent },
  { path: 'pptx-to-pdf', component: AppComponent },
  { path: 'terms-n-conditions', component: TermsNConditionsComponent },
  { path: 'privacy-n-policy', component: PrivacyNPolicyComponent },
  { path: 'blog', component: BlogToolComponent },
    // { path: 'tools', component: BlogComponent},
  { path: 'how-to-copy-text-from-pdf', component: CopyTextFromPdfComponent },
  { path: 'what-is-ocr-pdf', component: WhatIsOCRPDFComponent },
  { path: 'unlock-a-pdf-file-easily', component: UnlockAPdfFileEasilyComponent },
   { path: 'how-to-extract-pages-from-pdf', component: HowToExtractPagesFromPdfComponent },
   { path: 'merge-pdf-file-to-one-file', component: MergePdfFileToOneFileComponent },
   { path: 'remove-pdf-password-online', component: RemovePdfPasswordOnlineComponent },
   { path: 'convert-pdf-to-excel-online', component: ConvertPdfToExcelOnlineComponent },
   { path: 'convert-excel-to-pdf', component: ConvertExcelToPdfComponent },
   { path: 'combine-pdf-file-free', component: CombinePdfFileFreeComponent },
   { path: 'convert-word-to-png', component: ConvertWordToPngComponent },
   { path: 'journey-of-pdf', component: JourneyOfPdfComponent },
   { path: 'pdf-files-without-software', component: PdfFilesWithoutSoftwareComponent },

  // { path: 'blog-html-to-image', component: BlogHtmlToImageComponent },
  { path: 'blog-pdf-to-word', component: BlogPdfToWordComponent },
{ path: 'blog-html-to-pdf', component: BlogHtmlToPdfComponent },
{ path: 'blog-unlock-pdf', component: BlogUnlockPdfComponent },
{ path: 'blog-protect-pdf', component: BlogProtectPdfComponent },
{ path: 'blog-watermark-pdf', component: BlogWatermarkPdfComponent },
{ path: 'blog-pdf-to-excel', component: BlogPdfToExcelComponent },
{ path: 'blog-word-to-png', component: BlogWordToPngComponent },
{ path: 'blog-excel-to-pdf', component: BlogExcelToPdfComponent },
{ path: 'blog-pdf-to-image', component: BlogPdfToImageComponent },
{ path: 'blog-image-to-pdf', component: BlogImageToPdfComponent },
{ path: 'blog-word-to-pdf', component: BlogWordToPdfComponent },
{ path: 'blog-ocr-pdf', component: BlogOcrPdfComponent },
{ path: 'blog-pptx-to-pdf', component: BlogPptxToPdfComponent },
{ path: 'blog-compress-pdf', component: BlogCompressPdfComponent },
{ path: 'contact-us', component: ContectusComponent },
{ path: 'about-us', component: AboutusComponent },

  // { path: 'pdf-converter', component: DocumentUploadComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'blog-pdf-merge', component: BlogMergePdfComponent },
  { path: 'blog-pdf-split', component: BlogSplitPdfComponent },
  { path: '', component: AppComponent },
   { path: '**', redirectTo: '/' }  // Wildcard route for 404
];


